export const SEND_MESSAGE = "SEND_MESSAGE";
export const GET_CONVERSATIONS = "GET_CONVERSATIONS";
export const GET_CONVERSATION = "GET_CONVERSATION";
export const NEW_CONVERSATION_STARTED = "NEW_CONVERSATION_STARTED";
export const SEND_MESAGE_OUTSIDE = "SEND_MESAGE_OUTSIDE";
export const RESET_CONVERSATIONS = "RESET_CONVERSATIONS";
export const MESSENGER_AUTH_START = "MESSENGER_AUTH_START";
export const MESSENGER_AUTH_END = "MESSENGER_AUTH_END";
export const MESSENGER_AUTH_ERROR = "MESSENGER_AUTH_ERROR";
